import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

export const iconButton: {
  defaultProps?: ComponentsProps['MuiIconButton'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiIconButton'];
  variants?: ComponentsVariants<Theme>['MuiIconButton'];
} = {
  styleOverrides: {
    root({ theme }) {
      return {
        // L'application est dense : beaucoup de boutons-icônes font 24 à 30px,
        // ce qui se pointe très bien à la souris et se rate au pouce. On élargit
        // la zone tactile sans toucher à la taille dessinée de l'icône.
        [theme.breakpoints.down('md')]: {
          minWidth: 44,
          minHeight: 44,
        },
      };
    },
  },
};
